// Import the functions you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; 
import { getAuth, RecaptchaVerifier } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyCtbJ7CleGHhD5T0IeSvPWPRdHuIAxdy2s",
  authDomain: "beanclopedia.firebaseapp.com",
  projectId: "beanclopedia",
  storageBucket: "beanclopedia.firebasestorage.app",
  messagingSenderId: "793844854094",
  appId: "1:793844854094:web:ff26060bf3c170046b021f",
  measurementId: "G-XXKQ7ZJR1H"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);

export { db, auth, RecaptchaVerifier };
